module.exports = __webpack_public_path__ + "components/resort-guide/item/static/icon-drag-lift--black-70a98e1ccc5dd7703e8af40531d8b40f.svg";